import { render, staticRenderFns } from "./create_new_briefing.vue?vue&type=template&id=70ea2f56&scoped=true"
import script from "./create_new_briefing.vue?vue&type=script&lang=js"
export * from "./create_new_briefing.vue?vue&type=script&lang=js"
import style0 from "./create_new_briefing.vue?vue&type=style&index=0&id=70ea2f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea2f56",
  null
  
)

export default component.exports